// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlternanciaController from "./alternancia_controller"
application.register("alternancia", AlternanciaController)

import ColapsaveisController from "./colapsaveis_controller"
application.register("colapsaveis", ColapsaveisController)

import ExpansaoController from "./expansao_controller"
application.register("expansao", ExpansaoController)

import GraficoController from "./grafico_controller"
application.register("grafico", GraficoController)

import ImpressaoController from "./impressao_controller"
application.register("impressao", ImpressaoController)

import ItensController from "./itens_controller"
application.register("itens", ItensController)

import MarcacaoController from "./marcacao_controller"
application.register("marcacao", MarcacaoController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ProcessandoController from "./processando_controller"
application.register("processando", ProcessandoController)

import ProvedorModeloController from "./provedor_modelo_controller"
application.register("provedor-modelo", ProvedorModeloController)

import WhatsappController from "./whatsapp_controller"
application.register("whatsapp", WhatsappController)
